var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHint(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_hint",
    clipPath: "url(#clip0_8432_28357)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector",
    filter: "url(#filter0_d_8432_28357)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9333 0V4.26667H17.0667V0H14.9333ZM7.1552 7.77813L3.9552 4.57813L2.4448 6.08853L5.6448 9.28853L7.1552 7.77813ZM26.3552 9.28853L29.5552 6.08853L28.0448 4.57813L24.8448 7.77813L26.3552 9.28853ZM16 6.4C13.9664 6.39966 12.0009 7.13309 10.4647 8.46557C8.92838 9.79804 7.92448 11.6401 7.63733 13.6533L7.616 13.8027C7.45383 14.9242 7.5195 16.067 7.80908 17.1626C8.09865 18.2582 8.60618 19.2842 9.30133 20.1792C10.1184 21.2352 10.6667 22.2443 10.6667 23.2555V26.6667C10.6667 26.9496 10.779 27.2209 10.9791 27.4209C11.1791 27.621 11.4504 27.7333 11.7333 27.7333H20.2667C20.5496 27.7333 20.8209 27.621 21.0209 27.4209C21.221 27.2209 21.3333 26.9496 21.3333 26.6667V23.2555C21.3333 22.2443 21.8816 21.2352 22.6987 20.1792C24.0427 18.4427 24.7211 16.1792 24.384 13.8005L24.3627 13.6512C24.0751 11.6383 23.0709 9.79681 21.5347 8.46476C19.9985 7.13272 18.0333 6.39959 16 6.4ZM0 17.0667H4.26667V14.9333H0V17.0667ZM27.7333 17.0667H32V14.9333H27.7333V17.0667ZM12.8 32H19.2V29.8667H12.8V32Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_8432_28357",
    x: 0,
    y: 0,
    width: 32,
    height: 33,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8432_28357"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8432_28357",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8432_28357"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHint);
export default __webpack_public_path__ + "static/media/Hint.7918763b12f60d3db2eab0525126166c.svg";
export { ForwardRef as ReactComponent };